import React from "react";
import { getStableIdLabel } from "../utils/cmsLabels";
import CmsKeyChip from "./CmsKeyChip";

function ReadOnlyBadge({ id, label: labelOverride }) {
  if (!id) return null;

  const label = labelOverride || getStableIdLabel(id);

  return (
    <CmsKeyChip
      value={label}
      title={`Fixed item · id: ${id}`}
      variant="locked"
      prefixIcon={<i className="mdi mdi-lock-outline" />}
    />
  );
}

export default ReadOnlyBadge;
